import { NgModule }              from '@angular/core';
import { UIRouterUpgradeModule } from '@uirouter/angular-hybrid';

import { SharedModule }             from '../shared/shared.module';
import { TaxGroupActionsComponent } from './tax-group.actions.component';
import { TaxGroupComponent }        from './tax-group.component';
import { TaxGroupsService }         from './tax-groups.service';
import { TaxGroupsComponent }       from './tax-groups.component';
import { TaxGroupsStates }          from './tax-groups.states';
import { TableModule }              from '../table/table.module';

@NgModule({
  declarations: [
    TaxGroupActionsComponent,
    TaxGroupComponent,
    TaxGroupsComponent
  ],
  entryComponents: [
    TaxGroupActionsComponent
  ],
  imports: [
    SharedModule,
    TableModule,

    UIRouterUpgradeModule.forChild({ states: TaxGroupsStates })
  ],
  providers: [
    TaxGroupsService
  ]
})
export class TaxGroupsModule {}
